import {Component, Input} from '@angular/core';
import {kanServiceLogDialog} from "../../../dialogs/service-log-dialog/component";
import {MatDialog} from "@angular/material";
import {ServiceLog} from "../../../../../classes/serviceLog";
import {kanServicesService} from "../../../../services/services/services";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {Dog} from "../../../../../classes/dog";
import {kanContractsService} from "../../../../services/services/contracts";

@Component({
    selector: 'kan-dog-services',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
})
export class kanDogServices {
    @Input() private dog: Dog;
    public services: ServiceLog[];
    public filteredServices: ServiceLog[];
    public search: string;

    constructor(private dialog: MatDialog,
                private servicesService: kanServicesService,
                private contractsService: kanContractsService) {

    }

    ngOnInit(): void {
        this.getServices();
    }

    public getServices(): void {
        this.servicesService.getDogServicesLog(this.dog.id)
            .then((services) => {
                this.services = services;
                this.filter();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanServiceLogDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getServices();
            }
        });
    }

    public editServiceDialog(event, service) {
        let dialogRef = this.dialog.open(kanServiceLogDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog,
                serviceLog: service
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.getServices();
            }
        });
    }

    public removeService(event, service) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.servicesService.removeService(service)
                    .then((data) => {
                        this.getServices();
                    });
            }
        });
    }

    public showContract(event, service) {
        this.contractsService.showContract(service.service.contractId, service.userId, service.dogId);
    }

    public filter() {
        this.filteredServices = this.services.filter((service) => {
            let found = true;
            if (this.search) {
                let arr = this.search.split(' ');
                arr.forEach((item) => {
                    if (item) {
                        found = found && String(service.service.service).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1;
                    }
                });
            }

            return found;
        }).sort((service1, service2) => {
            return !service1.start ? -1 : !service2.start ? 1 : service1.start < service2.start ? 1 : service1.start > service2.start ? -1 : 0;
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/services/component.ts